import React, { BaseSyntheticEvent, useState } from "react";
import { Form } from "react-bootstrap";
import { useField } from "formik";
import { useTranslation } from "react-i18next";

interface StyledTimeInputProps {
  name: string;
  className?: string;
  onChange?: (e: BaseSyntheticEvent) => void;
  value?: string;
  min?: string;
  max?: string;
}

export const StyledTimeInput: React.FC<StyledTimeInputProps> = ({
  name,
  className = "",
  min,
  max,
  value,
}) => {
  const { t } = useTranslation();
  const [field, , helpers] = useField(name);
  const [errorMessage, setErrorMessage] = useState<string>("");

  const timeToMinutes = (time: string) => {
    const [h, m] = time.split(":").map(Number);
    return h * 60 + m;
  };

  const validateTime = (value: string) => {
    if (!value) return "";
    const valMinutes = timeToMinutes(value);

    if (min && valMinutes < timeToMinutes(min))
      return `${t("page.Time cannot be earlier than")} ${min}`;
    if (max && valMinutes > timeToMinutes(max))
      return `${t("page.Time cannot be later than")} ${max}`;

    return "";
  };

  const onChangeHandler = (e: BaseSyntheticEvent) => {
    const val = e.target.value;
    const error = validateTime(val);

    setErrorMessage(error);
    helpers.setValue(error ? "" : val);
  };

  return (
    <>
      <Form.Floating className={`customTimePicker ${className}`}>
        <div
          className={`input-group align-items-center border rounded-2 ${
            errorMessage ? "is-invalid border-danger" : "border-light"
          }`}
        >
          <input
            type="time"
            className="form-control border-0 rounded-2"
            {...field}
            value={value}
            onChange={(e) => onChangeHandler(e)}
            style={{ padding: "6px 8px" }}
            min={min}
            max={max}
            title={errorMessage}
          />
        </div>
      </Form.Floating>
    </>
  );
};
